module.exports = __webpack_public_path__ + "static/media/Googleplay.423d33a3.png";